<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Terms Of Service</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Terms Of Service</li>
            </ul>
        </div>
    </div>
</div>

<div class="about-area position-relative overflow-hidden space mt-auto" id="privacy-sec">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <p>Your access to and use of the service is conditioned on your acceptance of and compliance with these
                    terms. These terms apply to all visitors, users, and others who access or use the Service.</p>

                <p>By accessing or using the service you agree to be bound by these Terms. If you disagree with any
                    part of the terms then you may not access the Service.</p>
            </div>
            <div class="col-md-12">
                <h3>Accounts</h3>
                <p>When you create an account with us, you must provide us with information that is accurate, complete,
                    and
                    current at all times. Failure to do so constitutes a breach of the Terms, which may result in
                    immediate
                    termination of your account on our service.</p>

                <p>You are responsible for safeguarding the password that you use to access the service and for any
                    activities or actions under your password, whether your password is with our service or a
                    third-party
                    service.</p>

                <p>You agree not to disclose your password to any third party. You must notify us immediately upon
                    becoming
                    aware of any breach of security or unauthorized use of your account.</p>

                <h3></h3>Intellectual Property
                <p>The service and its original content, features, and functionality are and will remain the exclusive
                    property of Xipe Tech and its licensors.</p>

                <h3>Links To Other Web Sites</h3>
                <p>Our service may contain links to third-party websites or services that are not owned or controlled by
                    Xipe Tech.</p>

                <p>Xipe Tech has no control over and assumes no responsibility for, the content, privacy policies, or
                    practices of any third-party web sites or services. You further acknowledge and agree that Xipe Tech
                    shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged
                    to
                    be caused by or in connection with the use of or reliance on any such content, goods, or services
                    available on or through any such web sites or services.</p>

                <p>We strongly advise you to read the terms and conditions and privacy policies of any third-party
                    websites
                    or services that you visit.</p>

                <h3>Termination</h3>
                <p>We may terminate or suspend your account immediately, without prior notice or liability, for any
                    reason
                    whatsoever, including without limitation if you breach the Terms.</p>

                <p>Upon termination, your right to use the Service will immediately cease. If you wish to terminate your
                    account, you may simply discontinue using the Service.</p>

                <p>All provisions of the Terms which by their nature should survive termination shall survive
                    termination,
                    including, without limitation, ownership provisions, warranty disclaimers, indemnity, and
                    limitations of
                    liability.</p>

                <h3>Disclaimer</h3>
                <p>Your use of the Service is at your sole risk. The service is provided on an “AS IS” and “AS
                    AVAILABLE”
                    basis. The service is provided without warranties of any kind, whether express or implied,
                    including,
                    but not limited to, implied warranties of merchantability, fitness for a particular purpose,
                    non-infringement, or course of performance.</p>

                <h3>Governing Law</h3>
                <p>These terms shall be governed and construed in accordance with the laws of without regard to its
                    conflict of law provisions.</p>

                <p>Our failure to enforce any right or provision of these terms will not be considered a waiver of those
                    rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the
                    remaining
                    provisions of these Terms will remain in effect. These Terms constitute the entire agreement between
                    us
                    regarding our Service and supersede and replace any prior agreements we might have between us
                    regarding
                    the Service.</p>

                <h3>Changes</h3>
                <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a
                    revision is material we will try to provide at least 30 day’s notice prior to any new terms taking
                    effect. What constitutes a material change will be determined at our sole discretion.</p>

                <p>By continuing to access or use our Service after those revisions become effective, you agree to be
                    bound
                    by the revised terms. If you do not agree to the new terms, please stop using the Service.</p>

                <h3>Contact Us</h3>
                <p>If you have any questions about these Terms, please contact us.</p>
            </div>

        </div>
    </div>
</div>

<!--======== Footer Section ========-->
<app-footer></app-footer>